module.exports = __webpack_public_path__ + "img/bag.f1f1837d.svg";